export async function encryptCardNumber(cardNumber) {
  const CryptoJS = await import("crypto-js");

  return CryptoJS.AES.encrypt(
    cardNumber,
    import.meta.env.VITE_APP_SECRET_KEY,
  ).toString();
}

export async function decryptCardNumber(encryptedCardNumber) {
  const CryptoJS = await import("crypto-js");

  return CryptoJS.AES.decrypt(
    encryptedCardNumber,
    import.meta.env.VITE_APP_SECRET_KEY,
  ).toString(CryptoJS.enc.Utf8);
}
